import React from 'react';
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend,
    BarElement,
} from 'chart.js';
import { Bar } from 'react-chartjs-2';
import ResponsiveStack from '../utils/responsive-stack';
import Button from '@mui/material/Button';
import CenterDiv from '../utils/center-div';
import {colorList} from "../utils/colors-list";

ChartJS.register(
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend,
    BarElement
);

export const FinanceProjectionChart = ({ chartData, filter, handleFilter }) => {
    const data = {
        labels: chartData.labels,
        datasets: chartData.datasets.map((dataset, index) => ({
            ...dataset,
            borderWidth: 2,
            fill: true,
            tension: 0.3,
            backgroundColor: getChartColor(index, 0.2),
            borderColor: getChartColor(index, 1),
        })),
    };

    return (
        <div>
            <Bar
                data={data}
                options={{
                    responsive: true,
                    plugins: {
                        legend: { position: 'top' },
                        title: {
                            display: true,
                            text: `Finance Projections`,
                        },
                    },
                }}
            />

            {/*<CenterDiv>*/}
            {/*    <ResponsiveStack>*/}
            {/*        {filter !== 'year' && (*/}
            {/*            <Button onClick={() => handleFilter('year')}>Year</Button>*/}
            {/*        )}*/}
            {/*        {filter !== 'month' && (*/}
            {/*            <Button onClick={() => handleFilter('month')}>Month</Button>*/}
            {/*        )}*/}
            {/*        {filter !== 'day' && (*/}
            {/*            <Button onClick={() => handleFilter('day')}>Day</Button>*/}
            {/*        )}*/}
            {/*    </ResponsiveStack>*/}
            {/*</CenterDiv>*/}
        </div>
    );
};

// Uses the colorList from colors.js for consistent, varied chart colors
const getChartColor = (index, opacity = 1) => {
    const hex = colorList[index % colorList.length];
    return hexToRgba(hex, opacity);
};

// Converts HEX color to rgba string
const hexToRgba = (hex, alpha) => {
    const bigint = parseInt(hex.replace('#', ''), 16);
    const r = (bigint >> 16) & 255;
    const g = (bigint >> 8) & 255;
    const b = bigint & 255;
    return `rgba(${r}, ${g}, ${b}, ${alpha})`;
};
